import { render, staticRenderFns } from "./MainBody.vue?vue&type=template&id=42439e8e&"
import script from "./MainBody.vue?vue&type=script&lang=js&"
export * from "./MainBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports